import React from "react";
import AppHealthTab from "../components/AppHealthTab";

export default function HealthPage() {
  return (
    <div className="flex-1 overflow-y-auto bg-gray-950">
      <AppHealthTab app="voxlane" />
    </div>
  );
}
